/**
 * @desc 扣减库位库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.temp.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/temp`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
